import Log from '@lib/Log';

export const getJornayaId = (): string | null => {
  const jornayaIdInput = (document.getElementById('leadid_token') as HTMLInputElement);
  if (!jornayaIdInput) {
    Log.warn('[Util] jornaya id field not available');
    return null;
  }

  if (!jornayaIdInput.value) {
    Log.warn('[Util] jornaya id not set');
    return null;
  }

  return jornayaIdInput.value;
};
